import React from "react";
import { Link } from "react-router-dom";
import DesignResearchImage from "../../asset/homewhatwedo/design.png";
import ManufacturingImage from "../../asset/homewhatwedo/manufacturing.webp";
import PrecisionComponentsImage from "../../asset/homewhatwedo/precisioncomponents.webp";
import QualityImage from "../../asset/homewhatwedo/quality.png";
import TestingImage from "../../asset/homewhatwedo/testinghome.png";
import PackagingImage from "../../asset/packaging.png";
import "./WhatWeDo.css";

const services = [
  {
    number: "01",
    title: "Design, Research & Development",
    description:
      "From concept development to engineering validation, we turn demanding requirements into practical solutions.",
    image: DesignResearchImage,
    link: "/capabilities?section=research-development",
  },
  {
    number: "02",
    title: "Manufacturing",
    description:
      "Advanced conventional and CNC-VMC machinery, skilled teams and dependable production for critical components.",
    image: ManufacturingImage,
    link: "/capabilities?section=manufacturing",
  },
  {
    number: "03",
    title: "Precision Components",
    description:
      "High-precision components and assemblies manufactured to demanding dimensional and performance standards.",
    image: PrecisionComponentsImage,
    link: "/capabilities?section=precision-components",
  },
  {
    number: "04",
    title: "Quality",
    description:
      "A quality-first approach with documented controls and inspection at every stage of the manufacturing process.",
    image: QualityImage,
    link: "/capabilities?section=quality",
  },
  {
    number: "05",
    title: "Testing",
    description:
      "Testing and verification that help ensure every product performs reliably in its intended application.",
    image: TestingImage,
    link: "/capabilities?section=testing",
  },
  {
    number: "06",
    title: "Packaging & Forwarding",
    description:
      "Careful packing, handling and forwarding to protect precision products from our facility to your destination.",
    image: PackagingImage,
    link: "/capabilities?section=packing-forwarding",
  },
];

const WhatWeDo = () => (
  <section className="what-we-do" aria-labelledby="what-we-do-title">
    <div className="what-we-do__heading">
      <div>
        <p className="what-we-do__eyebrow">Our expertise</p>
        <h2 id="what-we-do-title">What we do</h2>
      </div>
      <p className="what-we-do__intro">
        From concept to certified production, we deliver reliable engineering
        solutions for industries where precision and performance matter.
      </p>
    </div>

    <div className="what-we-do__grid">
      {services.map((service) => (
        <Link className="what-we-do__card" to={service.link} key={service.number}>
          <div className="what-we-do__image-wrap">
            <img src={service.image} alt={service.title} />
            <span className="what-we-do__number">{service.number}</span>
          </div>
          <div className="what-we-do__card-content">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        </Link>
      ))}
    </div>
  </section>
);

export default WhatWeDo;
